export const APPEARANCES = {
  default: 'default',
  filled: 'filled',
  gradient: 'gradient',
};

export const COLORS = {
  default: 'default',
  warning: 'warning',
};

export const LABEL_POSITIONS = {
  leftBottom: 'left-bottom',
  centerBottom: 'center-bottom',
  rightBottom: 'right-bottom',
};

export const LABEL_GAPS = {
  small: 'small',
  medium: 'medium',
};

export const VARIABLES = {
  borderIndent: `var(--ws-highlighter-indent)`,
  borderWidth: `var(--ws-highlighter-border-width)`,
};
